import React, { useState } from "react";
import { FaChevronDown, FaInfoCircle } from "react-icons/fa";

import { MachineMaintenanceHelpContent } from "./machineMaintenanceHelpContent";
import FieldAppChecklistReports from "./FieldAppChecklistReports";

import "./FieldAppCalibrationPanel.css";
import "./FieldAppChecklistReports.css";

function FieldAppMaintenancePanel({ t, farmId, children }) {
  const [helpOpen, setHelpOpen] = useState(false);
  const [subTab, setSubTab] = useState("machine");

  return (
    <div className="field-app-calibration">
      <button
        type="button"
        className={`field-app-calibration-help${
          helpOpen ? " is-open" : " is-collapsed"
        }`}
        aria-expanded={helpOpen}
        onClick={() => setHelpOpen((open) => !open)}
      >
        <FaInfoCircle className="field-app-calibration-help-icon" aria-hidden />
        <div className="field-app-calibration-help-body">
          <strong>{t("Para que serve esta ferramenta?")}</strong>
          {helpOpen ? <MachineMaintenanceHelpContent /> : null}
        </div>
        <FaChevronDown
          className="field-app-calibration-help-chevron"
          aria-hidden
        />
      </button>
      <div className="field-app-maintenance-subtabs">
        <button
          type="button"
          className={subTab === "machine" ? "is-active" : ""}
          onClick={() => setSubTab("machine")}
        >
          {t("Manutenção da máquina")}
        </button>
        <button
          type="button"
          className={subTab === "checklist" ? "is-active" : ""}
          onClick={() => setSubTab("checklist")}
        >
          {t("Checklist ao assumir")}
        </button>
      </div>
      {subTab === "machine" ? (
        children
      ) : (
        <FieldAppChecklistReports farmId={farmId} t={t} />
      )}
    </div>
  );
}

export default FieldAppMaintenancePanel;
